import {BlobDto} from '../Blob/type'
import {XpertKnowledgeSectionDto} from '../XpertKnowledgeSection/type'
import {XpertKnowledgeActivityLogsDto} from '../XpertKnowledgeActivityLogs/type'

export enum XpertKnowledgeTutorialStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  IN_REVIEW = 'IN_REVIEW',
  REFUSED = 'REFUSED',
  DEPRECATED = 'DEPRECATED',
}

export enum XpertKnowledgeTutorialGenerationType {
  CLASSIC = 'CLASSIC',
  WITH_DOCS = 'WITH_DOCS',
}

export interface XpertKnowledgeTutorialDto {
  id: number
  title: string
  description: string
  equipmentType: string
  version: number
  status: XpertKnowledgeTutorialStatus
  audioBlob: BlobDto
  sections: XpertKnowledgeSectionDto[]
  activityLogs: XpertKnowledgeActivityLogsDto[]
  userRating?: XpertKnowledgeRatingDto
  avgRating?: number
  views: number
  generationType: XpertKnowledgeTutorialGenerationType
}

export interface XpertKnowledgeRatingDto {
  id: string
  rating: number
}

export interface UpdateXpertKnowledgeTutorialBody {
  title?: string
  description?: string
  equipment_type?: string
}

export interface RequestChangesXpertKnowledgeTutorialBody {
  comment: string
}

export interface SubmitXpertKnowledgeTutorialBody {
  comment: string
  title?: string
  description?: string
  equipment_type?: string
}

export interface CreateXpertKnowledgeTutorialBody {
  title: string
  position: number
  intro?: string
  conclusion?: string
}

export interface XpertKnowledgeTutorialDebugDto {
  chunks: Record<string, any>[]
  gptResponse: Record<string, any>
}
